// extracted by mini-css-extract-plugin
export default {"welcome":"index_welcome__5sINq"};